import React from 'react';
import './NextStepButton.css';

// A document header's Next button, beside its Actions menu: the one way to
// take the step the document is at ("Accept Order →", "Convert to SO →").
// The Actions menu keeps everything else. `hold` colours it amber, for
// Release Hold. Wrap the header Accordion in className "doc-header" so its
// controls drop to their own row on a narrow screen.
function NextStepButton({ label, onClick, disabled, hold }) {
  return (
    <button
      type="button"
      className={`next-step-button${hold ? ' hold' : ''}`}
      disabled={disabled}
      onClick={onClick}
    >
      {label} →
    </button>
  );
}

export default NextStepButton;
